export const DIALOG_ALERT_I18N_SUBNAMESPACE = "dialog_alert";
export const i18nPrefix = `translation:${DIALOG_ALERT_I18N_SUBNAMESPACE}.`;
